'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import Link from 'next/link'
import { Button } from '@/components/ui/Button'
import { FileText } from 'lucide-react'

export default function NotFound() {
  const pathname = usePathname()

  useEffect(() => {
    // If this is a CV route, redirect to the placeholder page with the CV ID
    if (pathname && pathname.startsWith('/cv/')) {
      const pathnameClean = pathname.replace(/\/$/, '') // Remove trailing slash

      // Recover from malformed URLs like: /cv/placeholder/cvId=<id>
      // (should be: /cv/placeholder?cvId=<id>)
      const malformedMatch = pathnameClean.match(/^\/cv\/placeholder\/cvId=([^\/]+)$/)
      if (malformedMatch && malformedMatch[1]) {
        const cvId = malformedMatch[1]
        window.location.replace(`/cv/placeholder?cvId=${encodeURIComponent(cvId)}`)
        return
      }

      const cvIdMatch = pathnameClean.match(/^\/cv\/([^\/]+)/)
      if (cvIdMatch && cvIdMatch[1] && cvIdMatch[1] !== 'placeholder') {
        const cvId = cvIdMatch[1]
        // Store CV ID in sessionStorage and redirect
        sessionStorage.setItem('cvRedirectId', cvId)
        // Use replace to avoid adding to history
        window.location.replace('/cv/placeholder')
        return
      }
    }
  }, [pathname])

  // If it's a CV route, show loading while redirecting
  if (pathname && pathname.startsWith('/cv/')) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-gray-600 cv-loading-delay">Loading CV...</p>
        </div>
      </div>
    )
  }

  // Otherwise show 404 page
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center max-w-md mx-auto px-4">
        <FileText className="w-16 h-16 text-gray-300 mx-auto mb-4" />
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Page Not Found</h1>
        <p className="text-gray-600 mb-6">The page you are looking for does not exist.</p>
        <Link href="/dashboard">
          <Button>Go to Dashboard</Button>
        </Link>
      </div>
    </div>
  )
}

